import { IRequestBody } from '../validateDateTime'

export default function(date: string, time: string): IRequestBody {
  return { date, time }
}
